import HelpModal from '@/components/on-board/HelpModal'

let onBoardStepMixin = {
  created() {
    let visitedRoutes =
      (localStorage.getItem('visitedRoutes') &&
        localStorage.getItem('visitedRoutes').split(',')) ||
      []
    const currentRoute = this.$route.name
    if (this.hasHelp && !visitedRoutes.includes(currentRoute)) {
      this.showHelpModal()
      visitedRoutes.push(currentRoute)
      localStorage.setItem('visitedRoutes', visitedRoutes.join(','))
    }
  },
  computed: {
    hasHelp() {
      return typeof this.$route.meta.extra.help !== 'undefined'
    }
  },
  methods: {
    showHelpModal() {
      let self = this
      this.$dlg.modal(HelpModal, {
        shaking: false,
        title: false,
        params: {
          content: '<p>' + self.$t(self.$route.meta.extra.help.text) + '</p>',
          bgColor: self.$route.meta.extra.colors.helpModal,
          number: self.$route.meta.extra.step.number,
          closeText: self.$t('Cerrar'),
          selectText: self.$t('Selecionar'),
          helpText: self.$t(self.$route.meta.extra.step.text)
        }
      })
    }
  }
}

export default onBoardStepMixin
